export const getUser = state => {
  if (
    state &&
    state.authentication &&
    state.authentication.user &&
    state.authentication.user.email
  ) {
    return state.authentication.user;
  }
  return false;
};


export const allUserRoles = state => {
  return (
    (state &&
      state.masterData &&
      state.masterData.metadata &&
      state.masterData.metadata.role) ||
    {}
  );
};